import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import buy from '@tencent/buy-ide';
import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';
import platform from '../../common/platform';
import cookie from '../../common/cookie';
import loader from '../../common/loader';
import { isFunction } from '../../common/base';

var DJCPay = /*#__PURE__*/function () {
  function DJCPay(option) {
    _classCallCheck(this, DJCPay);

    this.instance = {};
    this.instance.option = option;
  }

  _createClass(DJCPay, [{
    key: "pay",
    value: function pay() {
      var _this = this;

      var self = this;
      /*
              option:iActivityId,iFlowId,gameId,djcActId,sData.paytype,onPayError,version
              vesion:'v2'/'svr'
          */
      // 先拉取ams配置文件 add by weiztang 20220214

      console.log('milo:pay:init@1', this.instance.option);

      if (platform.isMobile()) {
        if (this.instance.option.sData && this.instance.option.sData.apptype === undefined) {
          this.instance.option.sData.apptype = 3;
        }
      } else {
        if (this.instance.option.sData && this.instance.option.sData.apptype === undefined) {
          this.instance.option.sData.apptype = 4;
        }
      }

      ams.amsInit(this.instance.option.iActivityId, this.instance.option.iFlowId, this.instance.option).then(function () {
        console.log('milo:pay:amsInit@2');

        if (_this.instance.option.gameId === undefined) {
          // if (this.instance.option.gameId === undefined || this.instance.option.djcActId === undefined) {
          // console.log('-9999,业务Id、道聚城活动Id不能为空')
          isFunction(_this.instance.option.onPayError) && _this.instance.option.onPayError({
            iRet: '-9999',
            sMsg: '参数缺失，业务Id、道聚城活动Id不能为空',
            option: _this.instance.option
          });
          return;
        } // apptype 1：点券 2：人民币 3：金币 4：点券+金币 5：金币2


        if (_this.instance.option.sData === undefined || _this.instance.option.sData.paytype === undefined) {
          // console.log('-9999,支付类型不能为空')
          isFunction(_this.instance.option.onPayError) && _this.instance.option.onPayError({
            iRet: '-9998',
            sMsg: '参数缺失，支付类型不能为空',
            option: _this.instance.option
          });
          return;
        } // 判断是移动端还是pc


        if (platform.isMobile()) {
          console.log('milo:pay:isMobile@3');
          self.getMobileBuyAppid().then(function (djcAppid) {
            console.log('milo:pay:getMobileBuyAppid.then@7');
            self.openPayDialog(djcAppid);
          });
        } else {
          console.log('milo:pay:isPC@3');
          self.getPCBuyAppid().then(function (djcAppid) {
            console.log('milo:pay:getPCBuyAppid.then@7');
            self.openPayDialog(djcAppid);
          });
        }
      })["catch"](function (err) {
        isFunction(_this.instance.option.onPayError) && _this.instance.option.onPayError({
          iRet: '-9994',
          sMsg: err.errMsg ? err.errMsg : 'ams初始化失败',
          option: _this.instance.option,
          err: err
        });
      });
    }
  }, {
    key: "getUrlParams",
    value: function getUrlParams() {
      var url = location.search; // 获取url中"?"符后的字串

      var theRequest = {};

      if (url.indexOf('?') != -1) {
        var str = url.substr(1);
        var strs = str.split('&');

        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
      }

      return theRequest;
    }
    /**
       * desc: PC端appid逻辑处理
       */

  }, {
    key: "getPCBuyAppid",
    value: function getPCBuyAppid() {
      var self = this;
      return new Promise(function (resolve) {
        console.log('milo:pay:getPCBuyAppid@4'); // 获取支付渠道的appid

        self.commonAct().then(function (djcActId) {
          console.log('milo:pay:commonAct.then@6');

          if (typeof window["final_appid_".concat(djcActId)] === 'undefined') {
            window["final_appid_".concat(djcActId)] = 1003; // 最终使用的appid

            var ret = window["json_act_".concat(djcActId)];

            if (ret && ret.sAppIds && ret.sBizCode) {
              window["legal_appid_".concat(djcActId)] = ret.sAppIds.split('|'); // 活动中配置的appid

              var all_appid = [1003, 1005, 2013, 2007, 1006, 1004]; // 目前所有的appid
              // 获取配置的pc端渠道

              for (var i = 0; i < all_appid.length; i++) {
                for (var j = 0; j < window["legal_appid_".concat(djcActId)].length; j++) {
                  if (window["legal_appid_".concat(djcActId)][j] == all_appid[i]) {
                    window["final_appid_".concat(djcActId)] = window["legal_appid_".concat(djcActId)][j];
                    resolve(window["final_appid_".concat(djcActId)]);
                    return;
                  }
                }
              }
            }
          } // 如果有 游戏内嵌


          if (self.getUrlParams().neiqian == 1) {
            window["final_appid_".concat(djcActId)] = 1006;
          }

          resolve(window["final_appid_".concat(djcActId)]);
        });
      });
    }
    /**
       * desc: 移动端appid逻辑处理
       */

  }, {
    key: "getMobileBuyAppid",
    value: function getMobileBuyAppid() {
      var self = this;
      return new Promise(function (resolve) {
        console.log('milo:pay:getMobileBuyAppid@4');
        self.commonAct().then(function (djcActId) {
          console.log('milo:pay:getMobileBuyAppid.then@6');

          if (typeof window["final_appid_".concat(djcActId)] === 'undefined') {
            var final_appid = self.appidByUserAgent(djcActId, self.instance.option.gameId);
            var ret = window["json_act_".concat(djcActId)];

            if (ret && ret.sAppIds && ret.sBizCode) {
              // 活动中配置的appid
              var legal_appid = ret.sAppIds.split('|'); // 如果ua判断出来的appid不在活动配置的渠道内

              if (!self._isInArray(legal_appid, final_appid)) {
                var all_appid = [2130, 1101, 1001, 2106, 2008, 2001, 2004, 2110, 1000, 2007, 1105, 2013, 2002, 2108, 2017, 1003, 2131]; // 目前H5支持的所有的appid

                for (var i = 0; i < all_appid.length; i++) {
                  for (var j = 0; j < legal_appid.length; j++) {
                    if (all_appid[i] == legal_appid[j]) {
                      final_appid = legal_appid[j];
                      window["final_appid_".concat(djcActId)] = final_appid;
                      resolve(final_appid);
                      return;
                    }
                  }
                }
              }
            } // 最终使用的appid
            // 曝光上报：一个模块多次调用此函数时，只上报一次


            window["final_appid_".concat(djcActId)] = final_appid;

            if (typeof window["already_reported_".concat(djcActId)] === 'undefined') {
              window["already_reported_".concat(djcActId)] = 1;
            }
          }

          resolve(window["final_appid_".concat(djcActId)]);
        });
      });
    }
    /**
       * desc: 获取道具城配置文件
       */

  }, {
    key: "commonAct",
    value: function commonAct() {
      console.log('milo:pay:commonAct@5');
      var self = this;
      var gameId = self.instance.option.gameId;
      var djcActId = self.instance.option.djcActId;

      try {
        if (!djcActId) {
          var _window, _window$ams_actdesc, _window$ams_actdesc$f, _window$ams_actdesc$f2;

          djcActId = (_window = window) === null || _window === void 0 ? void 0 : (_window$ams_actdesc = _window.ams_actdesc) === null || _window$ams_actdesc === void 0 ? void 0 : (_window$ams_actdesc$f = _window$ams_actdesc.flows["f_".concat(self.instance.option.iFlowId)]) === null || _window$ams_actdesc$f === void 0 ? void 0 : (_window$ams_actdesc$f2 = _window$ams_actdesc$f.functions[0]) === null || _window$ams_actdesc$f2 === void 0 ? void 0 : _window$ams_actdesc$f2.sExtModuleId;
        }
      } catch (e) {
        console.log('ams配置中无djcActId信息，请检查流程号或手动传入');
      }

      if (self.instance.option.gameId === 'codo') {
        gameId = 'codol';
      }

      if (self.instance.option.gameId === 'mh') {
        gameId = 'mho';
      }

      if (self.instance.option.gameId === 'nba2kx') {
        gameId = 'nba2k2';
      }

      return new Promise(function (resolve) {
        loader.loadScript("".concat(location.protocol, "//act.daoju.qq.com/time/act/js/").concat(gameId, "/act_").concat(djcActId, ".js")).then(function (isLoad) {
          if (isLoad) {
            resolve(djcActId);
          } else {
            // console.log('支付配置文件加载失败')
            isFunction(self.instance.option.onPayError) && self.instance.option.onPayError({
              iRet: '-9997',
              sMsg: '支付配置文件加载失败',
              option: self.instance.option
            });
          }
        });
      });
    } // 验证数组arr内是否存在value

  }, {
    key: "_isInArray",
    value: function _isInArray(arr, value) {
      for (var i = 0; i < arr.length; i++) {
        if (value == arr[i]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "openPayDialog",
    value: function openPayDialog(djcAppid) {
      var self = this;
      console.log('milo:pay:openPayDialog@8', this.instance.option);

      if (this.instance.option.sData) {
        this.instance.option.sData._app_id = djcAppid;
      } // 请求获取数据


      FlowEngine.submit({
        iActivityId: this.instance.option.iActivityId,
        iFlowId: this.instance.option.iFlowId,
        sNeedSubmitPopDiv: undefined === this.instance.option.sNeedSubmitPopDiv ? true : this.instance.option.sNeedSubmitPopDiv,
        sData: this.instance.option.sData,
        fFlowSubmitEnd: function fFlowSubmitEnd(retObj) {
          console.log('milo:pay:fFlowSubmitEnd@9', retObj); // console.log(retObj)

          if (retObj.jData && retObj.jData.ret == 0) {
            // 返回订单信息没有异常
            if (self.instance.option.sData.paytype == 2 || retObj.jData.iPayType === '2') {
              if (self.instance.option.version && self.instance.option.version === 'svr') {
                // svr
                console.log('milo:pay:buy.svrpay@10');
                buy.svrpay(retObj.jData, {
                  onPaySuccess: self.instance.option.onPaySuccess,
                  onPayClose: self.instance.option.onPayClose
                });
              } else {
                // v2
                console.log('milo:pay:buy.pay@10');
                buy.pay(retObj.jData, {
                  onPaySuccess: self.instance.option.onPaySuccess,
                  onPayClose: self.instance.option.onPayClose
                });
              }
            } else {
              isFunction(self.instance.option.onPaySuccess) && self.instance.option.onPaySuccess({
                iRet: '0',
                sMsg: 'Success',
                option: self.instance.option
              });
            }
          } else {
            isFunction(self.instance.option.onPayError) && self.instance.option.onPayError({
              iRet: retObj.jData.ret,
              sMsg: retObj.jData.msg,
              option: self.instance.option
            });
          }
        },
        fFlowSubmitFailed: function fFlowSubmitFailed(err) {
          isFunction(self.instance.option.onPayError) && self.instance.option.onPayError({
            iRet: '-9996',
            sMsg: '获取ams配置失败',
            option: self.instance.option
          }); // reject(err);

          console.log('milo:pay:fFlowSubmitFailed@9', err); // console.log(err)
        }
      })["catch"](function (err) {
        console.log('milo:pay:FlowEngine.catch@9'); // console.log(err)

        var errCode = '-9995';
        var errMsg = '系统繁忙，请稍后再试';

        if (err.errCode !== undefined) {
          errCode = err.errCode; // 增加未登录的错误提示

          if (errCode === '-1') {
            errMsg = '您还没有登录';
          }
        }

        if (err.iRet !== undefined) {
          errCode = err.iRet;
        }

        if (err.errMsg !== undefined) {
          errMsg = err.errMsg;
        }

        if (err.sMsg !== undefined) {
          errMsg = err.sMsg;
        }

        isFunction(self.instance.option.onPayError) && self.instance.option.onPayError({
          iRet: errCode,
          sMsg: errMsg,
          option: self.instance.option,
          err: err
        });
      });
    } // 通过ua判断出来的appid

  }, {
    key: "appidByUserAgent",
    value: function appidByUserAgent(actid) {
      // 特殊活动处理
      return this.getDJAppid(actid);
    }
    /**
       * 特殊活动处理
       * @param actid
       */

  }, {
    key: "getDJAppid",
    value: function getDJAppid(actid) {
      if (platform.isWxApp() && actid === 10168) {
        return 2002;
      }

      if (platform.isQQApp() && actid === 10168 || platform.isQQApp()) {
        return 1000;
      }

      if (platform.isQB()) {
        return 2131;
      }

      return this.dealUrlParams();
    }
    /**
       * url参数处理
       */

  }, {
    key: "dealUrlParams",
    value: function dealUrlParams() {
      var url = this.getUrlParams(); // 游戏内

      if (url.djc_appid == 2106 || url.djc_appid == '2106') {
        return 2106;
      } // 计平微商店


      if (url.jpwsd === 1 || url.jpwsd === '1') {
        return 2002;
      } // 直播活动


      if (url.zhibo === 1 || url.zhibo === '1') {
        return 2108;
      }

      return this.dealUserAgent();
    }
    /**
       * useragent处理
       */

  }, {
    key: "dealUserAgent",
    value: function dealUserAgent() {
      var self = this;
      var ua = navigator.userAgent.toLowerCase(); // 掌火

      if ((/GameHelper/.test(navigator.userAgent) || /cfapp/.test(navigator.userAgent)) && (self.instance.option.gameId === 'cf' || self.instance.option.gameId === 'cfm')) {
        return 2004;
      } // 掌盟


      if (ua.indexOf('lolapp') > -1) {
        return 2001;
      } // 游戏助手


      if (ua.indexOf('gamehelper') > -1) {
        return 2008;
      } // 游戏内嵌


      if (ua.indexOf('msdk') > -1 || location.host === 'gamein.daoju.qq.com1') {
        return 2106;
      }

      return this.dealApp();
    }
    /**
       * 检查是否再微信、道聚城app里
       */

  }, {
    key: "dealApp",
    value: function dealApp() {
      // 掌上道聚城
      if (cookie.get('djc_appVersion') != null) {
        return 1101;
      } // 微信


      if (platform.isWxApp()) {
        return 2110;
      }

      return 8888;
    }
  }]);

  return DJCPay;
}();

;
export default DJCPay;